define([
    'text!product-detail/furniture/knowledge-info-new.html',
    'product-detail/component/knowledge-group-new',
    'product-detail/component/knowledge-tabs',
    'product-detail/mixin/product',

    'lodash',

    'css!product-detail/furniture/knowledge-info-new.css'
], function(
    tpl,
    KnowledgeGroup,
    KnowledgeTabs,
    ProductMixin,
    _
){
    var items = [
        {title:'环保选材',subtitle:'Environmental protection',icon:'u-icon-search',image:'/view-v2/web/static/img/product-detail/image_env.jpg',field:'protection'},
        {title:'关于实木',subtitle:'Solid wood',icon:'u-icon-wood',image:'/view-v2/web/static/img/product-detail/image_wood.jpg',field:'artSolid'},
        {title:'关于工艺',subtitle:'Craftsman ship',icon:'u-icon-hammer',image:'/view-v2/web/static/img/product-detail/image_craft.jpg',field:'artCraftsman'},
        {title:'关于涂层',subtitle:'Coating',icon:'u-icon-brush',image:'/view-v2/web/static/img/product-detail/image_coating.jpg',field:'artCoating'},
        // {title:'关于面料',subtitle:'Fabric',icon:'u-icon-babric',imgWidth:'100%', field:'aboutCloth', image: '/view-v2/web/static/img/product-detail/image_cloth.jpg'},
        // {title:'关于包装',subtitle:'Package',icon:'u-icon-package',field:'aboutPackage', image: ''},
        // {title:'关于运送',subtitle:'Delivery',icon:'u-icon-truck',field:'artDelivery', image: ''}

    ];

    var itemss = [
        {title:'关于支付',subtitle:'Pay For',icon:'u-icon-money',field:'aboutPayGcr'},
        {title:'关于售后',subtitle:'Customer Service',icon:'u-icon-talk',field:'aboutServiceGcr'},
        {title:'关于运送',subtitle:'Delivery',icon:'u-icon-truck2',field:'aboutDeliveryGcr'}
    ];

    return {
        mixins: [ProductMixin],

        template: tpl,
        components: {
            KnowledgeGroup: KnowledgeGroup,
            KnowledgeTabs: KnowledgeTabs
        },
        data: function(){
            return {
                itemss: itemss
            };
        },
        computed: {
            items:function()
            {
                if(this.spuExtraBase.bom == 'F4-PF-001-01-02'
                    || this.spuExtraBase.bom == 'F4-Y-005-02-01'
                    || this.spuExtraBase.bom == 'F4-Y-004-01-01')
                    return  items;
                else
                {
                    items.splice(4,1);
                    return  items;
                }
            },
            groups: function(){
                return _.chunk(this.items, 1);
            },
            isPC: function () {
                if($(window).width()<=750){
                    $('.fixed-menu').css({display: 'none'});
                    return false;
                }else {
                    return true;
                }
            }
        },
        mounted: function(){
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/furniture/knowledge-info-new.js
// module id = 307
// module chunks = 0